import { ViewStateMetadata, ViewStateUpdateRequest } from '../../../../api/models/apis';
import { FORM_DATATYPES, TpAutoFormDef } from '../../../../components/auto-form-modal/AutoForm';
import { VISIBILITY_CONFIG } from '../constants/visibility-config';
import { VIEW_STATE_TERMS } from '../../../../data/snapshot/dashboardStateSerialization';

interface EditViewStateFormOptions {
  viewState: ViewStateMetadata;
  updateViewState: (stateId: string, updates: ViewStateUpdateRequest) => Promise<unknown>;
}

export function editViewStateForm({ viewState, updateViewState }: EditViewStateFormOptions): TpAutoFormDef {
  return {
    title: `Edit ${VIEW_STATE_TERMS.singular}`,
    fields: [
      {
        id: 'name',
        name: 'Name',
        dataType: FORM_DATATYPES.STRING,
        startContent: viewState.name,
        required: true,
        inputValidation: (content) => {
          const name = String(content).trim();
          return name.length > 0 && name.length <= 255;
        },
        ValidationMessage: 'Name must contain between 1 and 255 characters.',
      },
      {
        id: 'description',
        name: 'Description',
        dataType: FORM_DATATYPES.STRING,
        startContent: viewState.description || '',
        lineCount: 4,
      },
      {
        id: 'visibility',
        name: 'Visibility',
        dataType: FORM_DATATYPES.MULTIPLECHOICE,
        choices: Object.entries(VISIBILITY_CONFIG).map(([id, config]) => ({
          id,
          content: config.label,
        })),
        startContent: viewState.visibility,
        required: true,
      },
    ],
    actionButtons: [
      {
        id: 'cancel',
        content: 'Cancel',
      },
      {
        id: 'submit',
        content: 'OK',
        contentOnSubmit: 'Saving...',
        disabledOnSubmit: true,
      },
    ],
    submit: async (formData) => {
      await updateViewState(viewState.id, {
        name: String(formData.name).trim(),
        description: String(formData.description).trim() || null,
        visibility: String(formData.visibility),
      });
    },
  };
}
